/*** IMPORTS FROM imports-loader ***/
var define = false;
var jQuery = require("jquery");

/* 
plugin name:jquery.wg_combobox - v0.5.6 
time: 2014-08-21 03:08 
revision: 451068 
*/
/*
 The MIT License

 Copyright (C) 2013 Wargaming.net

 Permission is hereby granted, free of charge, to any person obtaining a copy of
 this software and associated documentation files (the "Software"), to deal in
 the Software without restriction, including without limitation the rights to
 use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 of the Software, and to permit persons to whom the Software is furnished to do
 so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
/*global define */
/**
 * module pattern for jquery plugin usage with requirejs
 */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        /*jshint unused:false*/
        define(['jquery', 'jquery.position', 'jquery.mCustomScrollbar'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($, undefined) {
    'use strict';

/*jshint unused:false*/
/*jshint -W079 */
var ControlState =  (function($, undefined) {
    'use strict';
    var ControlState = function(stateHolder, statesDescription) {
        this.element = stateHolder;
        this.states = statesDescription;
    };

    ControlState.prototype = {
        get: function(stateName) {
            return this.states[stateName];
        },

        set: function(stateName) {
            this.element.trigger('stateset', {state: this.states[stateName]});
        },
        unset: function(stateName) {
            this.element.trigger('stateunset', {state: this.states[stateName]});
        },
        removeAllStateClasses: function() {
            var state;

            for (state in this.states) {
                if (this.states.hasOwnProperty(state)) {
                    this.element.removeClass(state.jsStateClass);
                }
            }
        }
    };

    return ControlState;
})(jQuery);

/*jshint unused:false*/
/*jshint -W079 */

/**
 * Base Control module for jquery.wg_combobox control base functionality
 * 
 */
var BaseControl = (function($, ControlState, undefined) {
    'use strict';

    var BaseControlMixin =  {
        /**
         * Produced a BaseControl object
         *  
         * @param defaults
         * @param config
         * @param pluginName
         * @returns {BaseControl}
         */
        __Constructor: function(defaults, config, pluginName) {
            return function(element, options) {
                this.element = $(element);

                // deep options merge
                this.options = $.extend(true, {}, defaults, options);
                this.config = $.extend(true, {}, config, this.options.config);
                this.pluginName = pluginName || 'wgCombobox';

                this.init();
            };
        },

        /**
         * Method incorporating initialisation routine for BaseControl
         * 
         */
        init: function() {
            this.initStates();
            this.render();
            this.bindHandlers();
            this.parseStartStates();
        },

        /**
         * Initialisation ControlState object
         */
        initStates: function() {
            this.states = new ControlState(this.element, this.config.states);
        },

        /**
         * Method for render element wrappers
         */
        render: function() {
            this.element
                    .hide()
                    .wrap('<div tabindex="1">');
            this.wrapper = this.element.parent().addClass(this.config.wrapperClass);

            this.element.addClass(this.config.jsActivationClass);
        },

        /**
         * Method to bind handlers to events
         * 
         */
        bindHandlers: function() {
            var $this = this;
            this.element.on({
                'stateset.wgcombobox': function(e, data) {
                    var state = data.state;
                    if (state !== undefined && $this.states.states[state.stateName] !== undefined &&
                        !$this.isCurrentState(state)) {
                        $this.defaultHandler(state);
                    }
                },
                'stateunset.wgcombobox': function(e, data) {
                    var state = data.state;
                    if (state !== undefined) {
                        $this.defaultUnsetHandler(state);
                    }
                }
            });
        },


        unbindHandlers: function() {
            this.element.unbind('.wgcombobox');
            this.wrapper.unbind('.wgcombobox');
        },

        /**
         * The method which do the default action for the state: 
         * add state class to the element and to wrapper
         * @param state
         */
        defaultHandler: function(state) {
            this.element.addClass(state.jsStateClass);
            this.wrapper.addClass(state.wrapperStateClass);
        },

        /**
         * Removing state class from element and wrapper
         * @param state
         */
        defaultUnsetHandler: function(state) {
            this.element.removeClass(state.jsStateClass);
            this.wrapper.removeClass(state.wrapperStateClass);
        },

        /**
         * Read and init state which is set on the element on the start of page work
         */
        parseStartStates: function() {
            if (this.element.attr('disabled') !== undefined) {
                this.setState('disabled');
            }
        },

        /**
         * set state by its name
         * 
         * @param {string} stateName
         */
        setState: function(stateName) {
            this.states.set(stateName);
        },

        /**
         * unset state by stateName
         *
         * @public 
         * @param {string} stateName
         */

        unsetState: function(stateName) {
            this.states.unset(stateName);
        },

        /**
         * return state of the control by stateName
         *
         * @public 
         * @param {string} stateName
         * @returns {jQuery}
         */
        getState: function(stateName) {
            return this.states.get(stateName);
        },

        /**
         * return root wrapper around element
         * 
         * @public 
         * @returns {jQuery}
         */
        getWrapper: function() {
            return this.wrapper;
        },

        /**
         * return true if the control has disable state class 
         * 
         * @returns {boolean}
         */
        isDisabled: function() {
            var disableStateClass;

            if (this.config.states && this.config.states.disabled) {
                disableStateClass = this.config.states.disabled.jsStateClass;
            }

            return this.element.hasClass(disableStateClass);
        },

        /**
         * return jquery object of form element which are custom styled
         *  
         * @returns {jQuery}
         */
        getElement: function() {
            return this.element;
        },

        /**
         * check if state passed as parameter activated on the element
         *  
         * @param {ControlState} state
         * @returns {boolean}
         */
        isCurrentState: function(state) {
            return this.element.hasClass(state.jsStateClass);
        },

        /**
         * Remove all elements which have been added for component work
         * 
         */
        destroy: function() {
            this.unbindHandlers();
            this.states.removeAllStateClasses();

            this.element
                    .unwrap()
                    .removeData('plugin_' + this.pluginName);
        },

        proxifyJQueryEvents: function($element) {
            var self = this;

            $.each(['on', 'off', 'trigger'], function(i, eventName) {
                self[eventName] = function() {
                    $element[eventName].apply($element, arguments);
                };
            });
        }

    };

    return BaseControlMixin;
})(jQuery, ControlState);

/*jshint unused:false*/
/*jshint -W079 */
var InputControlMixin = (function($, BaseControl) {
    'use strict';

    var KEY_SPACE = 32;

    var InputControlMixin = {

        /**
         * from BaseControl
         *
         * @override
         */
        init: function() {
            this.findLabel();
            BaseControl.init.apply(this, arguments);
        },

        findLabel: function() {
            this.linkedLabel = $('label[for="' + this.element.attr('id') + '"]').addClass(this.config.labelClass);
        },

        /**
         * from BaseControl
         *
         * @override
         */
        render: function() {
            BaseControl.render.apply(this, arguments);
            this.wrapper.append($('<span>').addClass(this.config.checkerClass));

            this.linkedLabel.addClass(this.config.labelClass);
        },

        /**
         * from BaseControl
         * 
         * @override
         */
        parseStartStates: function() {
            BaseControl.parseStartStates.apply(this, arguments);

            if (this.element.attr('checked') !== undefined) {
                this.setState('checked');
            }
        },

        /**
         * from BaseControl
         * 
         * @override
         */
        bindHandlers: function() {
            var $this = this;

            BaseControl.bindHandlers.apply(this, arguments);
            this.wrapper.on({
                'click.wgcombobox': function() {
                    $this.checkedHandler();
                },
                'focus.wgcombobox mouseenter.wgcombobox': function() {
                    $this.setState('hovered');
                },
                'blur.wgcombobox mouseleave.wgcombobox': function() {
                    $this.unsetState('hovered');
                },
                'keydown.wgcombobox': function(e) {
                    return $this.keyHandler(e);
                }
            });

            this.bindLabel();

        },

        /**
         * bind handler to events to display control state changes for label
         * which is connected to the element
         * 
         * @private
         * 
         */
        bindLabel: function() {
            var $this = this;

            this.linkedLabel.on({
                'click.wgcombobox': function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $this.checkedHandler();
                },
                'mouseenter.wgcombobox': function() {
                    $this.setState('hovered');
                },
                'mouseleave.wgcombobox': function() {
                    $this.unsetState('hovered');
                }
            });
        },

        /**
         * handler to implement a keyboard navigation
         * 
         * @param e
         * @private
         * @returns {boolean}
         */
        keyHandler: function(e) {
            if (e.which === KEY_SPACE) {
                this.checkedHandler();
                return false;
            }
        },
        /**
         * Method used for update current control
         *
         * @public 
         */
        update: function() {
            this.linkedLabel.unbind('.wgcombobox');
            this.findLabel();
            this.bindLabel();
        },

        /**
         * from BaseControl
         * handler to implement change of the control state
         * 
         * @override
         * @private
         * @param state
         * @param saveState
         */
        defaultHandler: function(state, saveState) {
            var stateName = state.stateName;
            if (!this.isDisabled() || state.stateName === 'disabled') {
                BaseControl.defaultHandler.apply(this, arguments);

                if (saveState === undefined) {
                    saveState = true;
                }
                if (saveState) {
                    this.element.prop(stateName, true);
                    if (stateName === 'checked') {
                        this.element.trigger('change');
                    }
                }
                this.linkedLabel.addClass(state.labelStateClass);
            }
        },

        /**
         * from BaseControl
         * handler to implement appropriate removing of the control state 
         * 
         * @private
         * @param state
         */
        defaultUnsetHandler: function(state) {
            BaseControl.defaultUnsetHandler.apply(this, arguments);

            this.uncheckedHandler(state);
        },
        
        uncheckedHandler: function(state) {
            this.element.prop(state.stateName, false);
            this.linkedLabel.removeClass(state.labelStateClass);
        },

        /**
         * from BaseControl
         * correct unbind handlers
         * 
         * @override
         * 
         */
        unbindHandlers: function() {
            BaseControl.unbindHandlers.apply(this, arguments);
            this.linkedLabel.unbind('.wgcombobox');
        },

        /**
         * Handler to process the check action of the control
         */
        checkedHandler: function() {
            this.wrapper.focus();
            this.setState('checked');
        },

        /**
         * 
         * @public
         * @returns {jQuery}
         */
        getLinkedLabel: function() {
            return this.linkedLabel;
        },

        /**
         * return true if the control is checked
         *
         * @public 
         * @override 
         * @returns {boolean}
         */
        isChecked: function() {
            return this.element.hasClass(this.getState('checked').jsStateClass);
        },

        /**
         * from BaseControl
         *
         * @override
         */
        destroy: function() {
            this.linkedLabel.unbind('.wgcombobox');
            this.wrapper.remove('.' + this.config.checkerClass);
            BaseControl.destroy.apply(this, arguments);
        }
    };

    return InputControlMixin;
})(jQuery, BaseControl);

/*jshint unused:false*/
/*jshint -W079 */
var RadioControl = (function($, BaseControl, InputControlMixin) {
    'use strict';
    var radioConfig = {
        wrapperClass: 'b-radio',
        labelClass: 'b-combobox-label',
        checkerClass: 'b-radio_checker',
        jsActivationClass: 'js-wg_combobox-activated',
        states: {
            checked: {
                stateName: 'checked',
                jsStateClass: 'js-wg-state-checked',
                wrapperStateClass: 'b-radio__checked',
                labelStateClass: 'b-combobox-label__checked'
            },
            disabled: {
                stateName: 'disabled',
                jsStateClass: 'js-wg-state-disabled',
                wrapperStateClass: 'b-radio__disabled',
                labelStateClass: 'b-combobox-label__disabled'
            },
            hovered: {
                stateName: 'hovered',
                jsStateClass: 'js-wg-state-hovered',
                wrapperStateClass: 'b-radio__hover',
                labelStateClass: 'b-combobox-label__hover'
            }
        }
    };

    var defaults = {};

    var Radio = BaseControl.__Constructor(defaults, radioConfig);

    var KEY_DOWN = 40,
        KEY_UP = 38,
        KEY_RIGHT = 39,
        KEY_LEFT = 37;

    Radio.prototype = {};

    var RadioMixin = {
        init: function() {
            this.groupId = this.element.attr('name');
            this.findSameGroupEls();

            InputControlMixin.init.apply(this, arguments);
        },

        findSameGroupEls: function() {
            this.sameGroupEls = $('input[name="' + this.groupId + '"]');
        },

        update: function() {
            this.findSameGroupEls();
            InputControlMixin.update.apply(this, arguments);
        },

        keyHandler: function(e) {
            var which = e.which,
                element = this.element;

            if (which === KEY_DOWN || which === KEY_RIGHT) {
                this.checkNext(this.sameGroupEls.index(element));
                return false;
            } else if (which === KEY_UP || which === KEY_LEFT) {
                this.checkPrev(this.sameGroupEls.index(element));
                return false;
            }
        },

        checkNext: function(index) {
            var next = index + 1,
                nextElement;
            if (next < this.sameGroupEls.length) {
                nextElement = this.sameGroupEls.get(next);
                if (nextElement.disabled) {
                    this.checkNext(next);
                } else {
                    this.checkElement(nextElement);
                    return false;
                }
            }
        },

        checkPrev: function(index) {
            var prev = index - 1,
                prevElement;
            if (prev >= 0) {
                prevElement = this.sameGroupEls.get(prev);

                if (prevElement.disabled) {
                    return this.checkPrev(prev);
                } else {
                    this.checkElement(prevElement);
                    return false;
                }
            }
        },

        checkedHandler: function() {
            InputControlMixin.checkedHandler.apply(this, arguments);
            if (!this.isDisabled()) {
                this.uncheckOthers();
            }
        },

        /**
         * activate checked state on element passed as the parameter
         * 
         * @param element
         */
        checkElement: function(element) {
            var plugin = $.data(element, 'plugin_' + this.pluginName);

            if (plugin !== undefined) {
                plugin.wrapper.trigger('focus');
                plugin.checkedHandler();
            } else {
                this.unsetState('checked');
                $(this)
                    .focus()
                    .prop('checked', true)
                    .trigger('change');
            }
        },
        /**
         * set unchecked state for the others radio butthon in the same group
         *  
         * @private
         */
        uncheckOthers: function() {
            var current = this.element.get(0), $this = this;
            this.sameGroupEls.each(function() {
                var plugin = $.data(this, 'plugin_' + $this.pluginName);
                if (current === this) {
                    return;
                }
                if (plugin !== undefined) {
                    plugin.unsetState('checked');
                } else {
                    $(this)
                        .prop('checked', false)
                        .trigger('change');
                }
            });
        }
    };

    $.extend(Radio.prototype, BaseControl, InputControlMixin, RadioMixin);

    return Radio;
})(jQuery, BaseControl, InputControlMixin);

/*jshint unused:false*/
/*jshint -W079 */
var CheckboxControl = (function($, BaseControl, InputControlMixin) {
    'use strict';
    var checkboxControlConfig = {
        wrapperClass: 'b-checkbox',
        labelClass: 'b-combobox-label',
        checkerClass: 'b-checkbox_checker',
        jsActivationClass: 'js-wg_combobox-activated',
        states:{
            checked: {
                stateName: 'checked',
                jsStateClass: 'js-wg-state-checked',
                wrapperStateClass: 'b-checkbox__checked',
                labelStateClass: 'b-combobox-label__checked'
            },
            disabled: {
                stateName: 'disabled',
                jsStateClass: 'js-wg-state-disabled',
                wrapperStateClass: 'b-checkbox__disabled',
                labelStateClass: 'b-combobox-label__disabled'
            },
            hovered: {
                stateName: 'hovered',
                jsStateClass: 'js-wg-state-hovered',
                wrapperStateClass: 'b-checkbox__hover',
                labelStateClass: 'b-combobox-label__hover'
            }
        }
    };

    var defaults = {};

    var CheckboxControl = BaseControl.__Constructor(defaults, checkboxControlConfig);

    CheckboxControl.prototype = {};

    var CheckboxMixin = {

        /**
         * from InputControlMixin
         *
         * @override
         * 
         */
        checkedHandler: function() {
            this.isChecked() ? this.unsetState('checked') : this.setState('checked');
        },
        
        uncheckedHandler: function(state) {
            InputControlMixin.uncheckedHandler.apply(this, arguments);
            
            if (state.stateName === 'checked') {
                this.element.trigger('change');
            }
        }
    };

    $.extend(CheckboxControl.prototype, BaseControl, InputControlMixin, CheckboxMixin);

    return CheckboxControl;
})(jQuery, BaseControl, InputControlMixin);

/*jshint unused:false*/
/*jshint -W079 */
var KeyboardMixin = (function($) {
    'use strict';
    var KEY_ESCAPE = 27,
        KEY_ENTER = 13,
        KEY_DOWN = 40,
        KEY_UP = 38,
        KEY_RIGHT = 39,
        KEY_LEFT = 37,
        KEY_BACKSPACE = 8,
        KEY_TAB = 9,
        KEY_PAGE_DOWN = 34,
        KEY_PAGE_UP = 33,
        KEY_HOME = 36,
        KEY_END = 35,
        KEY_SPACE = 32,
        TYPING_TEXT_TIMEOUT = 300,
        PAGE_NAV_AMOUNT = 20,
        BACKSTROKE_OFFSET = 2,
        ESCAPE_REGEXP = /[-[\]{}()*+?.,\\^$|#\s]/g,
        ESCAPED_REPLACEMENT = '\\$&',
        REGEXP_ANCHOR = '^';

    var KeyboardMixin = {
        keyDownHandler: function(e) {
            if (e.altKey && e.which === KEY_DOWN && !this.dropdown.is(':visible')) {
                this.showDropdown();
                return false;
            }

            switch(e.which) {
            case KEY_ENTER:
                if (this.dropdown.is(':visible')) {
                    this.dropdown.trigger('dropdownhide');
                    this.selectHandler();
                } else {
                    this.activeHandler();
                }
                e.preventDefault();
                break;
            case KEY_SPACE:
                e.preventDefault();
                if (!this.dropdown.is(':visible')) {
                    this.showDropdown();
                }
                break;
            case KEY_DOWN:
                this.selectNext();
                e.preventDefault();
                break;
            case KEY_UP:
                this.selectPrev();
                e.preventDefault();
                break;
            case KEY_LEFT:
                e.preventDefault();
                this.selectPrev();
                break;
            case KEY_RIGHT:
                e.preventDefault();
                this.selectNext();
                break;
            case KEY_ESCAPE:
                e.preventDefault();
                this.dropdown.trigger('dropdownhide');
                break;
            case KEY_TAB:

                //close dropdown and refocus wrapper
                //need to support standard select behavior
                if (this.dropdown.is(':visible')) {
                    this.hideDropdown();
                    e.preventDefault();
                    this.wrapper.focus();
                }
                break;
            case KEY_PAGE_DOWN:
                this.selectNext(PAGE_NAV_AMOUNT);
                e.preventDefault();
                break;
            case KEY_PAGE_UP:
                this.selectPrev(PAGE_NAV_AMOUNT);
                e.preventDefault();
                break;
            case KEY_HOME:
                this.selectPrev('first');
                e.preventDefault();
                break;
            case KEY_END:
                this.selectNext('last');
                e.preventDefault();
                e.stopPropagation();
                break;
            case KEY_BACKSPACE:
                this.backspaceHandler();
                break;
            }
            return true;
        },

        keyPressHandler: function(e) {
            this.processLetters(e.which);
        },

        backspaceHandler: function() {
            var text = this.capturedText;
            this.capturedText = text.substring(0, text.length - BACKSTROKE_OFFSET);
            this.searchHandler(this.findFirst(this.capturedText, this.items));
        },

        processLetters: function(charCode) {
            var letter = String.fromCharCode(charCode), $this = this,
                typingTextTimeout;

            if (this.options && this.options.typingTextTimeout) {
                typingTextTimeout = this.options.typingTextTimeout;
            } else {
                typingTextTimeout = TYPING_TEXT_TIMEOUT;
            }

            if (!this.capturedText) {
                this.capturedText = '';
            }
            this.capturedText += letter;
            if (this.textTimeout !== undefined) {
                window.clearTimeout(this.textTimeout);
            }
            this.textTimeout = window.setTimeout(function() {
                $this.capturedText = '';
                $this.textTimeout = undefined;
            }, typingTextTimeout);

            this.searchHandler(this.findFirst(this.capturedText, this.items));
        },

        findFirst: function(text, items) {
            var i, len, textRegExp;

            textRegExp = new RegExp(REGEXP_ANCHOR + text.replace(ESCAPE_REGEXP, ESCAPED_REPLACEMENT), 'i');

            for (i = 0, len = items.length; i < len; i+=1 ) {
                if (textRegExp.test($.trim(items[i].text()))) {
                    return {
                        element: items[i],
                        index: i
                    };
                }
            }
        }
    };

    return KeyboardMixin;

})(jQuery);

/*jshint unused:false*/
/*jshint -W079 */
var SelectOptionControl = (function($, BaseControl) {
    'use strict';
    var selectOptionControlConfig = {
        wrapperClass: 'b-selectbox-dropdown_item',
        jsActivationClass: 'js-wg_combobox-activated',
        headingClass: 'b-selectbox-dropdown_item__heading',
        jsHeadingClass: 'js-wg-heading',
        states: {
            'selected': {
                stateName: 'selected',
                jsStateClass: 'js-wg-state-selected',
                wrapperStateClass: 'b-selectbox-dropdown_item__selected'
            }
        }
    };

    var defaults = {
        deleteOptionFromDropdown: false
    };

    var SelectOptionControl = BaseControl.__Constructor(defaults, selectOptionControlConfig);

    SelectOptionControl.prototype = {};

    var SelectOptionMixin = {
        init: function() {
            this.textString = this.element.text();
            BaseControl.init.apply(this, arguments);

            this.type = 'option';
        },

        render: function() {
            var config = this.config,
                options = this.options,
                wrapper;

            this.dropdownContent = options.dropdownContent;
            if (options.format === undefined) {
                wrapper =  $('<span>')
                                .text(this.textString)
                                .addClass(config.wrapperClass)
                                .addClass(options.styleClass);

            } else if (typeof options.format === 'function') {
                wrapper = options.format(this.element);
            } else {
                throw new Error('the options.format parameter should be function');
            }

            this.wrapper = wrapper;
            wrapper.wrap('<li/>');

            this.element.addClass(config.jsActivationClass);
        },

        bindHandlers: function() {
            var $this = this;

            BaseControl.bindHandlers.apply(this, arguments);
            this.wrapper.on({
                'click.wgcombobox': function() {
                    $this.selectedHandler();
                    $this.wrapper.trigger('dropdownhide');
                }
            });
        },

        getType: function() {
            return this.type;
        },

        defaultHandler: function(state) {
            var stateName = state.stateName;

            BaseControl.defaultHandler.apply(this, arguments);

            this.element.prop(stateName, true);

        },

        defaultUnsetHandler: function(state) {
            var stateName = state.stateName;

            BaseControl.defaultUnsetHandler.apply(this, arguments);

            this.element.prop(stateName, false);
        },

        selectedHandler: function(isApiCall) {

            //TODO: rename selectitem to itemselect
            this.element.trigger('selectitem', {element: this.element});
            this.setState('selected');

            if (!isApiCall) {
                this.element.trigger('userselectitem', {element: this.element});
            }
        },

        isSelected: function() {
            return this.element.hasClass(this.states.states.selected.jsStateClass);
        },

        getWrapperHeight: function() {
            return this.wrapper.outerHeight();
        },

        //the method is needed to support KeyboardMixin
        text: function() {
            return this.textString;
        },

        destroy: function() {
            this.wrapper.unbind('.wgcombobox');

            this.element.removeData('plugin_' + this.pluginName);
        }
    };

    $.extend(SelectOptionControl.prototype, BaseControl, SelectOptionMixin);

    SelectOptionControl.config = selectOptionControlConfig;

    return SelectOptionControl;
})(jQuery, BaseControl);

/*jshint unused:false*/
/*jshint -W079 */
var SelectOptionGroupControl = (function($, BaseControl) {
    'use strict';
    var selectOptionGroupControlConfig = {
        wrapperClass: 'b-selectbox-dropdown_content',
        additionalWrapperClass: 'b-selectbox-dropdown_content__embed',
        jsActivationClass: 'js-wg-heading',
        dropdownItemClass: 'b-selectbox-dropdown_item',
        headingItemClass: 'b-selectbox-dropdown_item__heading',
        states: {
        }
    };

    var defaults = {
        deleteOptionFromDropdown: false
    };

    var SelectOptionGroupControl = BaseControl.__Constructor(defaults, selectOptionGroupControlConfig);

    SelectOptionGroupControl.prototype = {};

    var SelectOptionGroupMixin = {
        init: function() {
            this.textString = this.element.attr('label');
            BaseControl.init.apply(this, arguments);

            this.type = 'optionGroup';
        },

        /**
         * render html markup for option group dom element of select
         * 
         */
        render: function() {
            var config = this.config,
                options = this.options,
                wrapper, container;

            container = $('<ul>')
                            .addClass(config.wrapperClass)
                            .addClass(config.additionalWrapperClass);

            this.dropdownContent = options.dropdownContent;
            if (options.format === undefined) {
                wrapper= $('<span>')
                                .text(this.textString)
                                .addClass(config.dropdownItemClass)
                                .addClass(config.headingItemClass)
                                .addClass(options.styleClass);
            } else if (typeof options.format === 'function') {
                wrapper = options.format(this.element);
            } else {
                throw new Error('the options.format parameter should be function');
            }

            this.wrapper = wrapper;
            this.container = container.append(wrapper
                                                .wrap('<li/>')
                                                .parent()
                                            );

            this.element.addClass(config.jsActivationClass);
        },

        bindHandlers: function() {
            var $this = this;

            BaseControl.bindHandlers.apply(this, arguments);
            this.wrapper.on({
                // click on the group label do nothing
                'click.wgcombobox': function() {
                    return false;
                }
            });
        },

        getType: function() {
            return this.type;
        },

        defaultHandler: function(state) {
        },

        defaultUnsetHandler: function(state) {
        },

        selectedHandler: function() {
        },

        isSelected: function() {
        },

        getContainer: function() {
            return this.container;
        },

        getWrapperHeight: function() {
            return this.wrapper.outerHeight();
        },

        //need to support KeyboardMixin
        text: function() {
            return this.textString;
        },

        destroy: function() {
            this.wrapper.unbind('.wgcombobox');

            this.element.removeClass(this.config.jsActivationClass);
            this.element.removeData('plugin_' + this.pluginName);
        }
    };

    $.extend(SelectOptionGroupControl.prototype, BaseControl, SelectOptionGroupMixin);

    SelectOptionGroupControl.config = selectOptionGroupControlConfig;

    return SelectOptionGroupControl;
})(jQuery, BaseControl);

/* global SelectControl */
/* global KeyboardMixin */
/*jshint unused:false*/
/*jshint -W079 */
var SelectControl = (function(
    $,
    BaseControl,
    SelectOptionControl,
    SelectOptionGroup,
    KeyboardMixin) {
    'use strict';
    var selectControlConfig = {
        wrapperClass: 'b-selectbox',
        textClass: 'b-selectbox_text',
        arrowbarClass: 'b-selectbox_arrow-bar',
        arrowClass: 'b-selectbox_arrow',
        dropdownWrapper: 'b-selectbox-dropdown',
        dropdownContent: 'b-selectbox-dropdown_content',
        jsActivationClass: 'js-wg_combobox-activated',
        ellipsisClass: 'b-selectbox-dropdown_item__line',
        measuringClass: 'b-selectbox-dropdown__measuring',
        jsHeadingClass: 'js-wg-heading',
        scrollBoxClass: 'mCustomScrollBox',
        scrollBoxContainerClass: 'mCSB_container',
        states: {
            'hovered': {
                stateName: 'hovered',
                jsStateClass: 'js-wg-state-hovered',
                wrapperStateClass: 'b-selectbox__hover'
            },
            'active': {
                stateName: 'active',
                jsStateClass: 'js-wg-state-active',
                wrapperStateClass: 'b-selectbox__active'
            },
            'opened': {
                stateName: 'opened',
                jsStateClass: 'js-wg-state-opened',
                wrapperStateClass: 'b-selectbox__open'
            },
            'disabled': {
                stateName: 'disabled',
                jsStateClass: 'js-wg-state-disabled',
                wrapperStateClass: 'b-selectbox__disabled'
            }
        }
    };

    var defaults = {
        mCustomScrollbarConfig: { // config for the mCustomScroll plugin, which used for custom scroll inside the dropdown
            scrollButtons: {
                enable: true
            },
            mouseWheel: true,
            scrollInertia: 0,
            advanced: {
                autoScrollOnFocus: false
            },
            theme: 'dark'
        },
        searchTimeout: 50, // timeout for search options inside select from a keyboard
        searchScrollInertia: 0, // intertia for the scroll when keyboard search is happened
        showDropdownDelay: 100, // delay for show dropdown
        typingTextTimeout: 300, // timeout for keyboard search - define time interval which separates chars inside one word
        updateItemPositionTimeout: 50, // timeout for additional scroll position update when navigate inside select with keyboard
        scrollAccurancy: 4, // option which define max difference between scrolled position and visible to the user oner
        visibleItems: 8, // the max number of options which will be shown without scroll
        scroll: false, // parameter which activated scroll inside the dropdown
        minDropdownHeight: 25, // the minimum dropdown height, which will be used when the sum height of options is lower then that parameter
        wrapperWidth: 'content', // the option which defines way how wrapper width is calculated
        itemsStyle: '', // if the option is equal to 'ellipsis' the style of the options will have ellipsis style
        format: undefined // hash with functions which is responsible for the formatting option items in the dropdown and result block
    };

    var WIDTH = 'width',
        AUTO = 'auto',
        EXPONENT = 6,
        MULTIPLYER =  Math.pow(10, EXPONENT);

    var SelectControl = BaseControl.__Constructor(defaults, selectControlConfig);

    SelectControl.prototype = {};

    var SelectMixin = {

        /**
         * from BaseControl
         * 
         * @private
         * @override
         */
        init: function() {
            this.options.format = this.initFormatFunctions(this.options.format);

            BaseControl.init.apply(this, arguments);
        },

        /**
         * init function for options formatting functions
         * 
         * @param format
         * @returns {*}
         */
        initFormatFunctions: function(format) {
            var resultFormats = {};

            if (typeof format === 'function') {
                resultFormats = {
                    result: format,
                    option: format,
                    optionGroup: format
                };
            } else if (typeof format === 'object') {

                if (format.option === undefined) {
                    return format;
                }

                resultFormats = format;

                if (format.optionGroup === undefined) {
                    resultFormats.optionGroup = format.option;
                }

                if (format.result === undefined) {
                    resultFormats.result = format.option;
                }
            }

            return resultFormats;
        },

        /**
         * from BaseControl
         * 
         * @override 
         */
        render: function() {
            var config = this.config,
                selectedItem = this.element.find('option').eq(this.element.get(0).selectedIndex);

            BaseControl.render.apply(this, arguments);

            this.jsSelectedItemClass = SelectOptionControl.config.states.selected.jsStateClass;
            this.body = $('body');
            this.emptySpan = $('<span>');

            this.textEl = $('<div>')
                                .addClass(config.textClass)
                                .append(this.formatSelectedItemText(selectedItem, this.options.format.result));
            this.arrowBar = $('<span>')
                                .addClass(config.arrowbarClass)
                                .append($('<a>')
                                .addClass(config.arrowClass));

            this.wrapper
                    .append(this.textEl)
                    .append(this.arrowBar);
            this.dropdownId = this.getUID();

            this.renderDropdown();

            this.setWrapperWidth();
            this.setDropdownWidth();
        },

        /**
         * format option for display results
         * 
         * @param selectedItem
         * @param format
         * @returns {jQuery}
         */
        formatSelectedItemText: function(selectedItem, format) {
            var textEl;

            if (format !== undefined) {
                textEl = format(selectedItem);
            } else {
                textEl = this.emptySpan.clone().text(selectedItem.text());
            }

            return textEl;
        },

        /**
         * init width option and set width for the root wrapper
         * 
         * @private
         * 
         */
        setWrapperWidth: function() {
            var options = this.options,
                wrapperWidth = options.wrapperWidth;

            switch (wrapperWidth) {
            case 'content':
                this.wrapper.css(WIDTH, this.calculateContentWidth());
                break;
            case 'dropdown':
                this.wrapper.css(WIDTH, options.dropdownWidth || this.getDropdownWidth());
                break;
            case 'text':
                this.wrapper.css(WIDTH, this.calculateTextWidth());
                break;
            default:
                this.wrapper.css(WIDTH, wrapperWidth || this.calculateContentWidth());
                break;
            }
        },

        /**
         * 
         * @public 
         * @returns {number}
         */
        getDropdownWidth: function() {
            return this.dropdown.width();
        },

        /**
         * calculate width of the dropdown
         * used if dropdown width is not fixedin styles or options
         * 
         * @private
         * @returns {number}
         */
        calculateContentWidth: function() {
            var dropdown = this.dropdown, resultWidth,
                measuringClass = this.config.measuringClass;

            dropdown.addClass(measuringClass);

            dropdown.show();

            resultWidth = dropdown.width();

            dropdown.hide();
            dropdown.removeClass(measuringClass);

            return resultWidth;
        },

        /**
         * 
         * @private
         * @returns {number}
         */
        calculateTextWidth: function() {
            var ARROWBAR_BORDER = 2,
                styleWidth, textWidth, measuringEl;

            styleWidth = parseInt(this.textEl.css('padding-left'), 10) +
                parseInt(this.textEl.css('padding-right'), 10) + ARROWBAR_BORDER;

            measuringEl = this.textEl
                                .clone()
                                .hide()
                                .addClass(this.config.measuringClass);

            this.body.append(measuringEl);

            measuringEl.show();

            textWidth = measuringEl.width();

            measuringEl.remove();

            textWidth += styleWidth;

            return textWidth;
        },

        /**
         * from BaseControl
         * 
         * @override
         */
        parseStartStates: function() {
            var index = this.element.get(0).selectedIndex;

            if (index >= 0) {
                this.items[index].selectedHandler();
            } else {
                this.items[0].selectedHandler();
            }
        },

        /**
         * render html layout for the dropdown
         *  
         * @private
         */
        renderDropdown: function() {
            var dropdown,
                config = this.config,
                dropdownContent;

            dropdownContent = $('<ul>').addClass(config.dropdownContent);

            dropdown = $('<div>')
                            .addClass(config.dropdownWrapper)
                            .addClass('js-dropdown-id-' + this.dropdownId)
                            .append(dropdownContent)
                            .hide();
            this.dropdown = dropdown;
            this.dropdownContent = dropdownContent;

            this.renderOptionItems();

            // Modified for WGPSS-818
            this.wrapper.parent().append(dropdown);

            if (this.isScroll()) {
                dropdown.css({
                    'height': this.calculateDropdownHeight() + 'px',
                    'overflow': 'hidden'
                });
                this.initScroll();
            }
        },

        /**
         * render markup for the option items elements
         * 
         * @private
         * 
         */
        renderOptionItems: function() {
            var dropdownContent = this.dropdownContent,
                parentElement = dropdownContent,
                item, group, $this = this,
                options = this.options,
                optionItemOptions = {
                    element: this,
                    addToSelect: false,
                    styleClass: '',
                    format: options.format.option
                },
                optionGroupOptions = {
                    format: options.format.optionGroup
                };

            optionGroupOptions = $.extend({}, optionItemOptions, optionGroupOptions);

            this.items = [];

            if (options.itemsStyle === 'ellipsis') {
                optionGroupOptions.styleClass = optionItemOptions.styleClass = this.config.ellipsisClass;
            }

            this.element.children().each(function() {
                var nodeName = this.nodeName.toLowerCase();

                if (nodeName === 'option') {
                    optionItemOptions.element = this;
                    item = $this.initSelectOption(this, optionItemOptions);

                    dropdownContent.append(item.getWrapper().parent());
                    parentElement = item.getWrapper().parent();
                }

                if (nodeName === 'optgroup') {
                    optionGroupOptions.parentElement = parentElement;
                    optionGroupOptions.element = this;
                    group = $this.initSelectOptionGroup(this, optionGroupOptions);
                    $this.activateSelectOptionGroupItems(group, optionGroupOptions);
                    parentElement.append(group.getContainer());
                }
            });
        },

        /**
         * util method to define if control should use the scroll inside dropdown
         * 
         * @returns {boolean}
         */
        isScroll: function() {
            return $.fn.mCustomScrollbar !== undefined && this.options.scroll;
        },

        /**
         * initialize scroll for the dropdown
         * 
         * @private
         * 
         */
        initScroll: function() {
            var dropdown = this.dropdown,
                scrollBox,
                config = this.config;

            dropdown.mCustomScrollbar(this.options.mCustomScrollbarConfig);
            scrollBox = dropdown.find('.' + config.scrollBoxClass);

            this.dropdown.trigger('scrolltoitem');


            this.scrollContainer = dropdown.find('.' + config.scrollBoxContainerClass);
            this.scrollBox = scrollBox;
        },

        /**
         * utils method for generating unique identifier
         * 
         * @returns {number}
         */
        getUID: function() {
            return Math.floor(Math.random() * MULTIPLYER);
        },

        initSelectOption: function(element, options) {
            var optionItem = this.initOption(SelectOptionControl, element, options);

            this.items.push(optionItem);

            return optionItem;
        },

        /**
         * proxy method to init option group
         * 
         * @param element
         * @param options
         * @returns {SelectOptionControl|SelectOptionGroupControl}
         */
        initSelectOptionGroup: function(element, options) {
            return this.initOption(SelectOptionGroupControl, element, options);
        },

        /**
         *  
         * @param {SelectOptionGroup} group
         * @param {*} groupItemsOptions
         */
        activateSelectOptionGroupItems: function(group, groupItemsOptions) {
            var groupContainer = group.getContainer(),
                groupElement = group.getElement(),
                $this = this;

            $(groupElement).children().each(function() {
                var item = $this.initSelectOption(this, {
                    addToSelect: groupItemsOptions.addToSelect,
                    styleClass: groupItemsOptions.styleClass,
                    parentElement: groupContainer
                });
                groupContainer.append(item.getWrapper().parent());
            });
        },

        /**
         * factory to produce SelectOptionControl and SelectOptionGroupControl
         *  
         * @param OptionContructor
         * @param element
         * @param options
         * @returns {SelectOptionControl|SelectOptionGroupControl}
         */
        initOption: function(OptionContructor, element, options) {
            var defaultOptions = {
                    element: undefined,
                    styleClass: '',
                    parentElement: this.element
                },
                optionItem;

            options = $.extend(true, {}, defaultOptions, options);

            optionItem = new OptionContructor(element, options);

            $.data(element, 'plugin_' + this.pluginName, optionItem);

            return optionItem;
        },

        /**
         *  
         * @public
         */
        setDropdownHeight: function() {
            var dropdown = this.dropdown,
                calculatedDropdownHeight = this.calculateDropdownHeight(),
                needUpdate = false;

            if (this.scrollBoxHeight !== calculatedDropdownHeight && this.isScroll()) {
                needUpdate = true;
                this.scrollBoxHeight = calculatedDropdownHeight;
            }


            dropdown.css({
                'height': calculatedDropdownHeight + 'px'
            });

            if (needUpdate && this.isScroll()) {
                dropdown.mCustomScrollbar('update');
            }
        },

        /**
         * 
         * @private
         * @returns {number}
         */
        calculateDropdownHeight: function() {
            var dropdown = this.dropdown, i, resultHeight = 0, prevHeight = 0,
                options = this.options,
                minDropdownHeight = options.minDropdownHeight, countingItems, items, item, hidden = false,
                measuringClass = this.config.measuringClass, len;

            // find all child elements for current select: options and optionGroups
            items = this.element.find('*');

            countingItems = options.visibleItems || items.length;

            if (!dropdown.is(':visible')) {
                dropdown
                    .addClass(measuringClass)
                    .show();
                hidden = true;
            }

            for (i = 0, len = items.length; countingItems !== 0 && i < len; i+=1) {
                item = items.eq(i).data('plugin_' + this.pluginName);

                if (item !== undefined && item.getWrapper().is(':visible')) {
                    prevHeight = item.getWrapperHeight();

                    if (item.getType() === 'option') {
                        countingItems -= 1;
                    }
                }

                resultHeight += prevHeight;
                prevHeight = 0;
            }

            if (hidden) {
                dropdown
                    .hide()
                    .removeClass(measuringClass);
            }

            return resultHeight > minDropdownHeight ? resultHeight : minDropdownHeight;
        },

        /**
         * set width of the dropdown
         * 
         * @private
         */
        setDropdownWidth: function() {
            var options = this.options,
                dropdown = this.dropdown,
                wrapperWidth = options.wrapperWidth,
                // Modified for WGPSS-818
                dropdownBorderWidth = dropdown.css('border-right-width'),
                dropdownWidth = parseInt(wrapperWidth) - 2 * parseInt(dropdownBorderWidth) +'px';

            switch (options.dropdownWidth) {
            case 'content':
                dropdown.css(WIDTH, AUTO);
                break;
            case 'parent':
                dropdown.css(WIDTH, dropdownWidth);
                break;
            default:
                dropdown.css(WIDTH, options.dropdownWidth || dropdownWidth || AUTO);
                break;
            }
        },

        /**
         * from BaseControl
         *
         * @override 
         * @private
         */
        bindHandlers: function() {
            var $this = this,
                dropdown = this.dropdown;

            BaseControl.bindHandlers.apply(this, arguments);

            this.element.on({
                'stateunset.wgcombobox': function(e, data) {
                    var state = data.state;
                    if (state.stateName === 'active') {
                        dropdown.trigger('dropdownhide');
                    }
                },
                'selectitem.wgcombobox': function(e, data) {
                    $this.selectItemHandler(data.element);
                }
            });

            this.wrapper.on({
                'click.wgcombobox': function(e) {
                    if (!$this.isCurrentState($this.getState('active')) || !$this.dropdown.is(':visible')) {
                        e.stopPropagation();
                        $this.activeHandler();
                    } else {
                        dropdown.trigger('dropdownhide');
                        $this.unsetState('opened');
                    }
                    return false;
                },
                'mouseenter.wgcombobox': function() {
                    $this.setState('hovered');
                },

                'mouseleave.wgcombobox': function() {
                    if (!$this.isCurrentState($this.getState('active'))) {
                        $this.unsetState('hovered');
                    }
                },

                'focus.wgcombobox': function() {
                    $this.setState('active');
                    $this.element.trigger('focus');
                    clearTimeout($this.focusTimeout);
                },

                'blur.wgcombobox': function() {
                    if ($this.dropdown.is(':visible')) {
                        $this.wrapper.focus();
                        $this.focusTimeout = setTimeout(function() {
                            $this.wrapper.trigger('blur');
                        }, 50);
                        return false;
                    } else {
                        $this.unsetState('active');
                        $this.unsetState('opened');
                        $this.unsetState('hovered');
                        $this.element.trigger('blur');
                        return true;
                    }
                },

                'keydown.wgcombobox ': function(e) {
                    return $this.keyDownHandler(e);
                },

                'keypress.wgcombobox': function(e) {
                    return $this.keyPressHandler(e);
                },

                'dropdownupdate.wgcombobox': function() {
                    $this.updateDropdown();
                }
            });

            dropdown.on({
                'click.wgcombobox': function(e) {
                    if ($(e.target).parents('.js-dropdown-id-' + $this.dropdownId).length === 0) {
                        dropdown.trigger('dropdownhide');
                        return true;
                    } else {
                        return false;
                    }
                },
                'dropdownhide.wgcombobox': function() {
                    $this.hideDropdown();
                },
                'scrolltoitem.wgcombobox': function() {
                    var selectedItem;

                    if ($this.isScroll()) {
                        selectedItem = $this.getSelectedItem() || $this.items[0].getElement();
                        $this.scrollToItem(selectedItem.data('plugin_' + $this.pluginName)
                                                                                    .getWrapper().parent());
                    }
                }
            });
        },

        /**
         * empty method to support keyboard mixin
         *
         * @private 
         * @implements KeyboardMixin
         */
        selectHandler: function() {

        },

        /**
         * method to support KeyboardMixin
         *
         * @implements KeyboardMixin 
         * @param searchResult
         */
        searchHandler: function(searchResult) {
            var $this = this;

            if (searchResult !== undefined) {
                setTimeout(function() {
                    $this.selectItem(searchResult.index, 0);
                }, this.options.searchTimeout);
            }
        },

        /**
         * method for correct dropdown hide
         *  
         * @public
         */
        hideDropdown: function() {
            this.dropdown.hide();
            this.body.unbind('.wg_dropdown' + this.dropdownId);
        },

        /**
         * handler which is resposible for the processing SelectOptionControl 
         * 'selectitem' events inside parent SelectControl
         * 
         * 
         * @private
         * @param selectedItem
         */
        selectItemHandler: function(selectedItem) {
            var selectedItemDom = selectedItem.get(0), $this = this,
                currentIndex =  selectedItemDom.index;

            $this.setText(selectedItem);

            $this.element.find('.' + this.jsSelectedItemClass).each(function() {
                if (this !== selectedItemDom) {
                    $.data(this, 'plugin_' + $this.pluginName).unsetState('selected');
                }
            });
            this.element.get(0).selectedIndex = currentIndex;
            this.element.trigger('change', {selected: selectedItem, index: currentIndex});
        },

        /**
         * return jquery object for option which is selected at the current moment
         * 
         * @public 
         * @returns {jQuery|undefined}
         */
        getSelectedItem: function() {
            var selectedIndex = this.element.get(0).selectedIndex;

            if (selectedIndex >= 0) {
                return this.items[selectedIndex].getElement();
            } else {
                return undefined;
            }
        },

        getSelectedValue: function() {
            var selectedItem = this.getSelectedItem();

            if (selectedItem !== undefined) {
                return selectedItem.attr('value');
            } else {
                return undefined;
            }
        },

        /**
         * Public method to set option in selected state if value param will be the same
         * 
         * @public
         * @param value
         * @returns {boolean}
         */
        setSelectedItemByValue: function(value) {
            var foundOption;

            $.each(this.items, function(index, optionItem) {
                var optionValue = optionItem.getElement().attr('value');

                if (value === optionValue) {
                    foundOption = optionItem;
                }
            });

            if (foundOption !== undefined) {
                foundOption.selectedHandler(true);
                return true;
            } else {
                return false;
            }
        },

        /**
         * method to select next option
         * 
         * @private
         * @implements KeyboardMixin
         * @param {number|string|undefined} offset
         */
        selectNext: function(offset) {
            var currentElement = this.element.find('option.' + this.jsSelectedItemClass),
                len, i, items = this.items;

            if (currentElement.length !== 0) {
                for ( i = 0, len = this.items.length - 1; i < len; i+=1) {
                    if (items[i].isSelected()) {
                        this.selectItem(i, offset);
                        return;
                    }
                }
            } else {
                this.selectItem(0, 0);
            }
        },

        /**
         * 
         * used to select item for internal needs
         * 
         * @private
         * @param index
         * @param offset
         * @param sign
         * @param scroll
         */
        selectItem: function(index, offset, sign, scroll) {
            var current = this.getActiveItem(),
                items = this.items,
                len = items.length,
                newIndex;

            sign = (sign === undefined) ? 1 : sign;
            offset = (offset === undefined) ? 1 : offset;
            scroll = (scroll === undefined) ? true : scroll;

            newIndex = index + offset * sign;

            if (offset === 'first') {
                this.selectItem(0, 0);
            } else if (offset === 'last') {
                this.selectItem(len - 1, 0);
            } else if (newIndex > len) {
                this.selectItem(len - 1, 0);
            } else if (newIndex < 0) {
                this.selectItem(0, 0);
            } else {
                current = items[newIndex];
                current.selectedHandler();

                if (scroll && this.isScroll()) {
                    this.scrollToItem(current.getWrapper().parent());
                }
            }
        },

        /**
         * 
         * @public
         * @param {jQuery} current
         */
        scrollToItem: function(current) {
            var calculatedOffset = this.calculateOffset(current),
                options = this.options,
                scrollOptions = {scrollInertia: options.searchScrollInertia},
                $this = this,
                dropdown = this.dropdown;

            var delayedUpdate = function() {
                dropdown.mCustomScrollbar('scrollTo', $this.calculateOffset(current));
            };

            dropdown.mCustomScrollbar('scrollTo', calculatedOffset, scrollOptions);

            //async update for scroll position when dropdown zone has size not multiple of
            //number of visible items inside it
            setTimeout(delayedUpdate, options.updateItemPositionTimeout);
        },

        /**
         * calculate item offset for the scroll inside the dropdown
         *
         * @private 
         * @param {jQuery} item
         * @returns {number}
         */
        calculateOffset: function(item) {
            //get current offset of scroll container as initial value
            var resultOffset = Math.abs(parseInt(this.scrollContainer.css('top'), 10)),
                scrollAccurancy = this.options.scrollAccurancy,
                topDiff = this.scrollBox.offset().top - item.offset().top,
                bottomDiff = topDiff + this.scrollBoxHeight -  item.outerHeight(true);

            if (topDiff > -scrollAccurancy) {
                resultOffset -= topDiff;
            } else if (bottomDiff < scrollAccurancy) {
                resultOffset += -bottomDiff;
            }

            return resultOffset;
        },

        /**
         * return selected item
         *
         * @public 
         * @returns {jQuery}
         */
        getActiveItem: function() {
            return this.items[this.element.get(0).selectedIndex].getElement();
        },

        /**
         * return array of SelectOptionControls which represents the options inside select element
         * 
         * @public
         * @returns {Array}
         */
        getItems: function() {
            return this.items;
        },

        /**
         * selecting the prev item in option list
         *  
         * @param {number|string} offset
         */
        selectPrev: function(offset) {
            var currentElement = this.element.find('option.' + this.jsSelectedItemClass),
                len, i, items = this.items;

            if (currentElement.length !== 0) {
                for ( i = 1, len = items.length; i < len; i+=1) {
                    if (items[i].isSelected()) {
                        this.selectItem(i, offset, -1);
                        return;
                    }
                }
            } else {
                this.selectItem(0, 0);
            }
        },

        /**
         * Set select results text
         *  
         * @public
         * @param optionEl
         */
        setText: function(optionEl) {
            this.text = optionEl.text();

            this.textEl
                    .empty()
                    .append(
                        this.formatSelectedItemText(optionEl, this.options.format.result)
                    );

            if (this.options.wrapperWidth === 'text') {
                this.wrapper.css('width', this.calculateTextWidth());
            }
        },

        getText: function() {
            return this.text;
        },

        /**
         * stub method
         *  
         * @orivate
         */
        unsetSelected: function() {
        },

        /**
         * handler for active state
         * 
         */
        activeHandler: function() {
            this.setState('active');
            this.setState('opened');
            this.wrapper.trigger('alldropdownshide');
            this.showDropdown();
            this.dropdown.trigger('dropdownshow');
        },

        /**
         * 
         * @public
         */
        updateScroll: function() {
            this.dropdown.mCustomScrollbar('update');
        },

        /**
         * update dropdown state: position, height, scroll
         *  
         * @public
         */
        updateDropdown: function() {
            this.setDropdownHeight();
            this.dropdown.setPosition(this.wrapper, {type: 'DROPDOWN'});

            if (this.isScroll()) {
                this.updateScroll();
            }
        },

        /**
         * showing dropdown
         * 
         * @public
         * 
         */
        showDropdown: function() {
            var $this = this,
                body = this.body,
                dropdown = this.dropdown;

            this.setDropdownHeight();

            dropdown
                .css({'visibility': 'hidden'})
                .setPosition(this.wrapper, {type: 'DROPDOWN'})
                .show()
                .trigger('scrolltoitem');

            if (this.isScroll()) {
                this.updateScroll();
            }

            body.on('click.wg_dropdown' + $this.dropdownId, function() {
                $this.unsetState('active');
                $this.unsetState('opened');
            });

            body.on('alldropdownshide.wgcombobox.wg_dropdown' + $this.dropdownId, function() {
                dropdown.trigger('dropdownhide');
            });

            setTimeout(function() {
                dropdown.css({'visibility': 'visible'});
            }, this.options.showDropdownDelay);
        },

        /**
         * 
         * @param {ControlState} state
         */
        defaultHandler: function(state) {
            if (!this.isDisabled() || state.stateName === 'disabled') {
                BaseControl.defaultHandler.apply(this, arguments);
            }
        },

        getDropdown: function() {
            return this.dropdown;
        },

        //TODO: update demo with these api
        update: function() {

            $.each(this.items, function() {
                this.destroy();
            });

            this.renderDropdown();

            this.setDropdownHeight();
            this.setDropdownWidth();
            this.setWrapperWidth();
        },

        destroy: function() {
            this.body.unbind('.wg_dropdown' + this.dropdownId);

            if (this.isScroll()) {
                this.dropdown.mCustomScrollbar('destroy');
            }

            this.textEl.remove();
            this.arrowBar.remove();

            $.each(this.items, function() {
                this.destroy();
            });

            this.dropdown
                    .unbind('.wgcombobox')
                    .remove();

            BaseControl.destroy.apply(this, arguments);
        }
    };

    $.extend(true, SelectControl.prototype, BaseControl, KeyboardMixin, SelectMixin);
    return SelectControl;
})(jQuery, BaseControl, SelectOptionControl, SelectOptionGroupControl, KeyboardMixin);

/*jshint unused:false*/
/*jshint -W079 */
var MultiSelectOptionControl = (function($, SelectOptionControl) {
    'use strict';

    var multiSelectOptionControlConfig = {
        wrapperClass: 'b-selectbox-dropdown_item',
        jsActivationClass: 'js-wg_combobox-activated',
        headingClass: 'b-selectbox-dropdown_item__heading',
        choiceWrapperClass: 'b-selectbox-choices_choice',
        choiceCloseClass: 'b-selectbox-choices_close',
        states: {
            'selected': {
                stateName: 'selected',
                jsStateClass: 'js-wg-state-selected',
                wrapperStateClass: 'b-selectbox-dropdown_item__selected'
            }
        }
    };

    var defaults = {
        mCustomScrollbarConfig: {
            scrollButtons: {
                enable: true
            },
            scrollInertia: 0,
            advanced: {
                autoScrollOnFocus: false
            }
        }
    };

    var MultiSelectOptionControl = SelectOptionControl.prototype.__Constructor(defaults, multiSelectOptionControlConfig);

    MultiSelectOptionControl.prototype = {};

    var MultiSelectOptionControlMixin = {
        render: function() {
            var CLOSE_TEXT = 'close',
                config = this.config,
                options = this.options;

            // container for store selected options
            this.choicesEl = options.choicesEl;

            // wrapper for option text element
            this.wrapper =  $('<span>')
                                    .text(this.textString)
                                    .addClass(config.wrapperClass)
                                    .addClass(options.styleClass);

            this.closeEl = $('<a>')
                                .addClass(config.choiceCloseClass)
                                .attr('href','#')
                                .text(CLOSE_TEXT);

            this.choiceEl = $('<li>')
                                .addClass(config.choiceWrapperClass)
                                .append($('<span>')
                                                .text(this.textString))
                                .append(this.closeEl);

            this.dropdownEl = this.wrapper.wrap('<li/>');

            this.element.addClass(config.jsActivationClass);
        },

        bindHandlers: function() {
            var $this = this;

            BaseControl.bindHandlers.apply(this, arguments);

            this.wrapper.on({
                'click.wgcombobox': function() {
                    $this.selectedHandler();
                }
            });

            this.closeEl.on('click', function() {
                $this.unselectedHandler();
                return false;
            });
        },

        selectedHandler: function() {
            this.choicesEl.append(this.choiceEl);
            this.dropdownEl.hide();

            SelectOptionControl.prototype.selectedHandler.apply(this, arguments);

            this.element.trigger('dropdownupdate');

        },

        unselectedHandler: function() {
            this.unsetState('selected');

            this.choiceEl.detach();
            this.dropdownEl.show();

            this.element.trigger('unselectitem', {element: this.element});
            this.element.trigger('dropdownupdate');
        }
    };

    $.extend(MultiSelectOptionControl.prototype,  SelectOptionControl.prototype, MultiSelectOptionControlMixin);

    return MultiSelectOptionControl;
})(jQuery, SelectOptionControl);

/*jshint unused:false*/
/*jshint -W079 */
var MultiSelectOptionGroupControl = (function($, BaseControl, SelectOptionControl, SelectOptionGroupControl) {
    'use strict';
    var multiSelectOptionGroupControlConfig = {
        wrapperClass: 'b-selectbox-dropdown_content',
        additionalWrapperClass: 'b-selectbox-dropdown_content__embed',
        jsActivationClass: 'js-wg-heading',
        dropdownItemClass: 'b-selectbox-dropdown_item',
        headingItemClass: 'b-selectbox-dropdown_item__heading',
        states: {
        }
    };

    var defaults = {
        deleteOptionFromDropdown: true
    };

    var MultiSelectOptionGroupControl = SelectOptionGroupControl.prototype.__Constructor(defaults, multiSelectOptionGroupControlConfig);

    var MultiSelectOptionGroupMixin = {
        init: function() {
            this.textString = this.element.attr('label');
            this.type = 'optionGroup';
            this.children = this.element.children();
            this.isShown = true;

            BaseControl.init.apply(this, arguments);
        },

        render: function() {
            var config = this.config,
                options = this.options,
                wrapper, container;

            container = $('<ul>')
                            .addClass(config.wrapperClass)
                            .addClass(config.additionalWrapperClass);

            this.dropdownContent = options.dropdownContent;
            if (options.format === undefined) {
                wrapper= $('<span>')
                    .text(this.textString)
                    .addClass(config.dropdownItemClass)
                    .addClass(config.headingItemClass)
                    .addClass(options.styleClass);
            } else if (typeof options.format === 'function') {
                wrapper = options.format(this.element);
            } else {
                throw new Error('the options.format parameter should be function');
            }

            this.wrapper = wrapper;

            this.container = container.append(wrapper.wrap('<li/>').parent());

            this.element.addClass(config.jsActivationClass);
        },

        bindHandlers: function() {
            var $this = this;

            SelectOptionGroupControl.prototype.bindHandlers.apply(this, arguments);

            this.element.on({
                'selectitem.combobox': function(e, data) {
                    $this.hideGroupHeading(data.element.get(0));
                },
                'unselectitem.combobox': function(e, data) {
                    $this.showGroupHeading(data.element.get(0));
                }
            });
        },

        hideGroupHeading: function(currentItem) {
            var groupItems = this.children,
                allSelected = true;

            groupItems.each(function() {
                if (currentItem !== this && !$(this).hasClass(SelectOptionControl.config.states.selected.jsStateClass)) {
                    allSelected = false;
                }
            });

            if(allSelected && this.isShown || this.children.length === 1) {
                this.wrapper.hide();
                this.isShown = false;
                this.element.trigger('dropdownupdate');
            }
        },

        showGroupHeading: function(currentItem) {
            var groupItems = this.children,
                allSelected = true;

            groupItems.each(function() {
                if (currentItem !== this && !$(this).hasClass(SelectOptionControl.config.states.selected.jsStateClass)) {
                    allSelected = false;
                }
            });

            if (!this.isShown) {
                this.wrapper.show();
                this.isShown = true;
            }
        },

        getType: function() {
            return this.type;
        },

        /**
         * Empty method to stub BaseControl api
         * 
         */
        defaultHandler: function() {
        },

        /**
         * Empty method to stub BaseControl api
         *
         */
        defaultUnsetHandler: function(state) {
        },

        /**
         * Empty method to stub BaseControl api
         *
         */
        selectedHandler: function() {
        },

        /**
         * Empty method to stub BaseControl api
         *
         */
        isSelected: function() {
        },

        getContainer: function() {
            return this.container;
        },

        getWrapperHeight: function() {
            return this.wrapper.outerHeight();
        },

        //need to support KeyboardMixin
        text: function() {
            return this.textString;
        },

        destroy: function() {
            this.wrapper.unbind('.wgcombobox');

            this.element.removeData('plugin_' + this.pluginName);
            SelectOptionGroupControl.prototype.destroy.apply(this, arguments);
        }
    };

    MultiSelectOptionGroupControl.prototype = $.extend({}, SelectOptionGroupControl.prototype,  MultiSelectOptionGroupMixin);

    MultiSelectOptionGroupControl.config = multiSelectOptionGroupControlConfig;

    return MultiSelectOptionGroupControl;
})(jQuery, BaseControl, SelectOptionControl, SelectOptionGroupControl);

/*jshint unused:false*/
/*jshint -W079 */
var MultiSelectControl = (function(
    $,
    BaseControl,
    SelectControl,
    MultiSelectOptionControl,
    MultiSelectOptionGroupControl) {
    'use strict';

    var config = {
        wrapperClass: 'b-selectbox',
        textClass: 'b-selectbox_text',
        choicesClass: 'b-selectbox-choices',
        arrowbarClass: 'b-selectbox_arrow-bar',
        arrowClass: 'b-selectbox_arrow',
        dropdownWrapper: 'b-selectbox-dropdown',
        dropdownContent: 'b-selectbox-dropdown_content',
        jsActivationClass: 'js-wg_combobox-activated',
        ellipsisClass: 'b-selectbox-dropdown_item__line',
        measuringClass: 'b-selectbox-dropdown__measuring',
        scrollBoxClass: 'mCustomScrollBox',
        jsHeadingClass: 'js-wg-heading',
        scrollBoxContainerClass: 'mCSB_container',
        states: {
            'hovered': {
                stateName: 'hovered',
                jsStateClass: 'js-wg-state-hovered',
                wrapperStateClass: 'b-selectbox__hover'
            },
            'active': {
                stateName: 'active',
                jsStateClass: 'js-wg-state-active',
                wrapperStateClass: 'b-selectbox__active'
            },
            'disabled': {
                stateName: 'disabled',
                jsStateClass: 'js-wg-state-disabled',
                wrapperStateClass: 'b-selectbox__disabled'
            }
        }
    };

    var defaults = {
        mCustomScrollbarConfig: {
            scrollButtons: {
                enable: true
            },
            scrollInertia: 0,
            advanced: {
                autoScrollOnFocus: false
            },
            theme: 'dark'
        },
        searchTimeout: 50,
        searchScrollInertia: 0,
        showDropdownDelay: 100,
        typingTextTimeout: 300,
        updateItemPositionTimeout: 50,
        scrollAccurancy: 4,
        visibleItems: 8,
        minDropdownHeight: 25
    };

    var MultiSelectControl = BaseControl.__Constructor(defaults, config);

    MultiSelectControl.prototype = {};

    var MultiSelectControlMixin = {
        render: function() {
            var config = this.config;
            BaseControl.render.apply(this, arguments);

            this.body = $('body');

            this.arrowBar = $('<span>')
                                    .addClass(config.arrowbarClass)
                                    .append($('<a>')
                                                .addClass(config.arrowClass));
            this.choicesEl = $('<ul>').addClass(config.choicesClass);

            this.wrapper
                    .append(this.choicesEl)
                    .append(this.arrowBar);

            this.dropdownId = this.getUID();
            this.renderDropdown();

            this.renderStartText();
            this.setWrapperWidth();
            this.setDropdownWidth();
        },

        renderStartText: function() {
            var placeholder = this.element.data('placeholder'),
                selectedItem;
            if (placeholder === undefined) {
                selectedItem = this.getSelectedItem() || this.items[0].getElement();
                placeholder = $.trim(selectedItem.text());
            }
            this.textEl = $('<div>')
                                .addClass(this.config.textClass)
                                .append(
                                    $('<span>').text(placeholder)
                                );
            if (this.choicesEl.children().length === 0) {
                this.choicesEl.hide();
                this.wrapper.append(this.textEl);
            }

        },

        showPlaceholder: function() {
            this.textEl.show();
        },

        hidePlaceholder: function() {
            this.textEl.hide();
        },

        keyHandler: function() {

        },

        initOption: function(OptionContructor, element, options) {
            options.choicesEl = this.choicesEl;

            return SelectControl.prototype.initOption.call(this, OptionContructor, element, options);
        },

        selectItemHandler: function(selectedItem) {
            if (this.choicesEl.children().length !== 0) {
                this.hidePlaceholder();
                this.choicesEl.show();
            }
            this.element.trigger('change', {selected: selectedItem});
        },

        unselectedHandler: function() {
            if (this.choicesEl.children().length === 0) {
                this.showPlaceholder();
                this.choicesEl.hide();
            }
        },

        parseStartStates: function() {
            var i, len, items = this.items, current;
            for (i = 0, len = items.length; i < len; i++) {
                current = items[i];
                if (current.element.get(0).selected) {
                    current.selectedHandler();
                }
            }

        },

        bindHandlers: function() {
            var $this = this;
            SelectControl.prototype.bindHandlers.apply(this, arguments);

            this.element.on({
                'unselectitem': function() {
                    $this.unselectedHandler();
                }
            });

            this.wrapper.on({
                'focus': function() {
                    //$this.textEl.hide();
                },
                'blur': function() {
                    if ($this.choicesEl.children().length === 0) {
                        $this.textEl.show();
                    }
                }
            });
        },
        /**
         * Override method from SelectControl to support multiselect options
         * 
         * @param {jQuery} element
         * @param {object} options
         * @returns {MultiSelectOptionControl}
         */
        initSelectOption: function(element, options) {
            var optionItem = this.initOption(MultiSelectOptionControl, element, options);

            this.items.push(optionItem);

            return optionItem;
        },

        /**
         * Override method from SelectControl to support multiselect options 
         * 
         * @param {jQuery} element
         * @param {Object} options
         * @returns {MultiSelectOptionGroupControl}
         */
        initSelectOptionGroup: function(element, options) {
            return this.initOption(MultiSelectOptionGroupControl, element, options);
        }

    };

    $.extend(MultiSelectControl.prototype, SelectControl.prototype, MultiSelectControlMixin);


    return MultiSelectControl;
})(
    jQuery,
    BaseControl,
    SelectControl,
    MultiSelectOptionControl,
    MultiSelectOptionGroupControl
);

(function($, SelectControl, RadioControl, CheckboxControl, MultiSelectControl) {
    'use strict';

    /*jshint unused:false*/
    var pluginName = 'wgCombobox';

    /**
     * Plugin constructor
     *
     * @constructor
     * @this {Plugin}
     * @param {jQuery} element 
     * @param {*} options 
     */
    function Plugin(element, options) {
        var type,
            nodeName = element.nodeName.toLowerCase(),
            controlType,
            isOptionsExist = options ? true : false;

        //detect control type 
        if (nodeName === 'input') {
            type = $(element).attr('type');
            if (type === 'radio') {
                controlType = 'radio';
            } else if (type === 'checkbox') {
                controlType = 'checkbox';
            }
        } else if (nodeName === 'select') {
            if ((isOptionsExist && options.type === 'select') ||
                (isOptionsExist && options.type !== 'multiselect') ) {
                controlType = 'select';
            } else if ((isOptionsExist && options.type === 'multiselect') || (element && element.multiple)) {
                controlType = 'multiselect';
            } else {
                controlType = 'select';
            }
        }

        // activate Control by defined control type
        switch (controlType) {
        case 'checkbox':
            return new CheckboxControl(element, options);
        case 'radio':
            return new RadioControl(element, options);
        case 'select':
            return new SelectControl(element, options);
        case 'multiselect':
            return new MultiSelectControl(element, options);
        default :
            throw new Error('incorrect invocation of wgCombobox plugin: you need apply it to input or select');
        }
    }

    
    // mapping for plugin public methods
    /*jshint unused:false*/
    var publicMethods = {
        'update' : 'update',
        'getElement': 'getElement',
        'setState': 'setState',
        'unsetState': 'unsetState'
    };

    $.fn[pluginName] = function(options) {
        var otherArguments = Array.prototype.slice.call(arguments, 1);

        return this.each(function() {
            var value = this;
            // check if plugin already exist for this element
            if (!$.data(value, 'plugin_' + pluginName)) {
                // create new Plugin instance for current element
                $.data(value, 'plugin_' + pluginName, new Plugin(value, options));
                return $.data(value, 'plugin_' + pluginName);
            } else if (publicMethods[options]) {
                // apply public method if plugin already created for the current element
                // here we use only mapped methods inside  publicMethods variable
                //TODO: need to remove plugin_
                var plugin = $.data(value, 'plugin_' + pluginName);
                return plugin[publicMethods[options]].apply(plugin, otherArguments);
            }
        });
    };

})(jQuery, SelectControl, RadioControl, CheckboxControl, MultiSelectControl);

}));

